// import React from "react";
// import ReactDOM from "react-dom/client";
// // import ReactDOM from "react-dom";
// //
// import "rc-slider/assets/index.css";
// // STYLE
// import "./styles/index.scss";
// import "./index.css";
// import "./fonts/line-awesome-1.3.0/css/line-awesome.css";

// //
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// ReactDOM.render(
//   <App />,
//   document.getElementById("root")
// );

// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );

// const MemoizedApp = React.memo(App);

// root.render(
//   // <React.StrictMode>
//   <MemoizedApp />
//   // </React.StrictMode> */}
// );

import React from "react";
import { createRoot } from "react-dom/client";
import "rc-slider/assets/index.css";
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import App from "./App";
import { initLocale } from "i18n/locale";
import 'react-toastify/dist/ReactToastify.css';

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = createRoot(rootElement);

/**
 * Settle the language before the first paint.
 *
 * A visitor in France or Belgium opens the site in French, everyone else in
 * English, and the choice is made from their address by the API — which the
 * browser cannot do for itself. Waiting for that answer costs a moment on a
 * first visit only: a returning visitor, and anyone who has used the language
 * switcher, is served from storage with no request at all.
 *
 * initLocale never rejects and bounds its own wait, so the site opens even
 * with the API unreachable — in English, which is the specified default.
 */
initLocale().finally(() => {
  root.render(
    <App />
  );
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
